import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Spin } from 'antd';
import styled from 'styled-components';
import ResponsiveImage from '../ResponsiveImage'

const DetailsPreview = ({ dlObject, angularScope, endpoint }) => {

  let iframeRef = useRef(null);

  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    
    let cancelToken = null;
    let previewPaneLoaded = () => { }

    const openPreview = () => {
      let previewObject = {
        id: dlObject.ID,
        version: dlObject.Version,
        minor: dlObject.Minor
      }
      angularScope.$broadcast('loadObjectPreview', previewObject);
    }

    if (dlObject.ID) {

      setLoading(true);
        
      axios.get(`/api/preview/getpreview?id=${dlObject.ID}&version=${dlObject.VersionID}&minor=${dlObject.Minor}`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancelToken = c;
        })
      }).then((res) => {

        setPreview(res.data);
        setLoading(false);

        previewPaneLoaded = angularScope.$on('previewLoaded', function (event, data) {

          if (data && data.isImage) {
            window.document.body.querySelector('.image-preview').addEventListener('dblclick', openPreview)
          }
          else {
            iframeRef.current && iframeRef.current.contentWindow.document.body.querySelector('#viewerContainer').addEventListener('dblclick', openPreview)
          }

          previewPaneLoaded();
          return null;
        })
      }).catch(() => {})
    }
    return () => {
      cancelToken && cancelToken();
      previewPaneLoaded();
    }

  }, [dlObject, angularScope])

  // Electron - set endpoint for PDF URL
  const encodedFilename = encodeURIComponent(preview.path);
  const framePath = endpoint ? `${endpoint}${encodedFilename}` : encodedFilename;

  return (
    <IframContainer>
      {preview.isImage && !loading && (
        <ResponsiveImage
          imagePath={decodeURIComponent(framePath)}
          leftRightPadding="50"
          topBottomPadding="125"
          headerCompensate="40"
          angularScope={angularScope}
        />
      )}
      {!preview.isImage && framePath !== 'undefined' && !loading && (
        <PreviewFrame
          ref={iframeRef}
          src={`/lib/pdf.js/web/viewer.html?file=${framePath}`}
        />
      )}
      {(framePath === 'undefined' || loading) && (
        <SpinContainer>
          <Spin style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: '45%' }} size="large" />
        </SpinContainer>
      )}      
    </IframContainer>
  )
}

const IframContainer = styled.div`
  padding: 0 !important;
  height: 100%;
  overflow: hidden;
  width: 350px;
  position: relative;
  box-sizing: border-box;
  background-color: #f8f9f9;
`
const PreviewFrame = styled.iframe`
  background-color: #f8f9f9;
`
const SpinContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const mapStateToProps = state => { 
  const { endpoint } = state.app;
  return { endpoint };
};

export default connect(mapStateToProps)(DetailsPreview);